import { RewardBalance } from "@factory/model/query-model-reward";
import "./customer-level.scss";
import { ProgressBar } from "primereact/progressbar";
import ProgressBarWithLabel from "../centered-progress-bar/centered-progress-bar";

export interface CustomerLevelProps {
  avatar?: string;
  balance: RewardBalance;
}

export function CustomerLevel({ avatar, balance }: CustomerLevelProps) {
  // DECLARATIONS

  // API DEFINITIONS

  // LOCAL FUNCTIONS

  // LOCAL RENDERS
  const valueTemplate = () => (
    <div className="text-xs font-semibold">
      {balance?.exp_points}/{balance?.next_level_points_cap}
    </div>
  );

  return (
    <div
      id="CustomerLevel"
      className="customer-level w-full flex flex-col items-center"
    >
      <div className="flex items-center mb-2 space-x-2">
        <img src={avatar} className="w-10 h-10 rounded-full" />
        <p className="text-xs font-semibold">Rank: {balance?.level_name}</p>
      </div>
      <div className="w-[80%] mb-2">
        <ProgressBarWithLabel
          current={balance?.exp_points}
          total={balance?.next_level_points_cap}
          unit="points"
          color="#5e17eb"
        />
      </div>
      <p className="text-xs font-semibold mb-5">
        Next Rank: {balance?.next_level_name}
      </p>
    </div>
  );
}

export default CustomerLevel;
